import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-bottom-buttons',
  templateUrl: './bottom-buttons.component.html',
  styleUrls: ['./bottom-buttons.component.css']
})
export class BottomButtonsComponent implements OnInit {
  private user_id:string;
  private user_name:string;
  private user_email:string;

  constructor() { }

  ngOnInit(): void {
    var user = firebase.default.auth().currentUser;
    this.user_id = user.uid;
    this.user_email = user.email;
    this.user_name = user.displayName;
  }

  shareClicked(buttonName: string, shareButton?: string) {
    firebase.default.analytics().logEvent(buttonName, {
      'uid': this.user_id,
      'email': this.user_email,
      'name': this.user_name,
      'media': shareButton
    })
  }

  buttonClicked(buttonName: string) {
    firebase.default.analytics().logEvent(buttonName, {
      'uid': this.user_id,
      'email': this.user_email,
      'name': this.user_name,
    })
  }

  communityClicked(buttonName: string, community?: string) {
    firebase.default.analytics().logEvent(buttonName, {
      'uid': this.user_id,
      'email': this.user_email,
      'name': this.user_name,
      'community': community
    })
  }

}
